<template>
  <div class="w-full col-span-full overflow-visible">
    <info-bulle
      v-if="libelle"
      :libelle="labelLibelle"
      :name="name"
      :is-libelle-input="true"
    >
      <template #libelleBefore>
        <div
          :for="name"
          :class="libelleStyle + ' truncate mb-2 flex items-center gap-x-1'"
          :style="
            inherits != undefined && inherits != null && inherits
              ? 'color: inherit; font-size: inherit; font-weight: inherit;'
              : ''
          "
          @mouseover="tooltipLibelle = true"
          @mouseleave="tooltipLibelle = false"
        >
          {{ libelle }} <span v-if="required" class="text-pink-600">*</span>
          <div
            v-if="libelleIcon"
            @click.stop="$emit('clickIcon')"
            class="cursor-pointer"
          >
            <icon :name="libelleIcon" :class="libelleIconStyle" />
          </div>
        </div>
      </template>
      <template #tooltipLibelleBefore>
        <!-- Display libelle when hover -->
        <transition
          enter-active-class="duration-300 delay-1000"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="
              tooltipLibelle &&
              libelle != null &&
              libelle != '' &&
              mutableValue != undefined
            "
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ libelle }}
          </div>
        </transition>
      </template>
    </info-bulle>
    <div
      class="inline-block relative w-full"
      @mouseover="tooltipValue = true"
      @mouseleave="tooltipValue = false"
    >
      <div
        v-if="icon && icon != null && icon != ''"
        class="absolute top-1.5 md:top-2.5 xxl:top-3 2xl:top-4 left-3 xxl:left-4 2xl:left-5 flex items-center cursor-pointer"
      >
        <icon :name="icon" class="text-indigo-600" />
      </div>
      <!-- valueIsObject determine if value is an object with more information or just a value. The object has to have a value called "value" -->
      <input
        readonly
        :required="required"
        :name="name"
        class="select-input bg-white border border-opacity-50 rounded-md placeholder-gray-600 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 appearance-none transition duration-150 ease-in-out sm:leading-5 truncate"
        v-model="computedValue"
        onkeydown="return false;"
        autocomplete="off"
        style="caret-color: transparent !important"
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
        :class="{
          'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
          'cursor-pointer': !(disabled || disabled_pass),
          'text-lg pr-7 pl-5 xxl:pr-8 2xl:pr-9 py-5':
            big != null && big && (icon === null || icon === ''),
          'text-lg pr-7 pl-15 xxl:pr-8 2xl:pr-9 py-5':
            big != null && big && !(icon === null || icon === ''),
          'text-sm pl-3 pr-7 py-2 xxl:pl-4 xxl:pr-8 xxl:py-3 2xl:pl-5 2xl:pr-9 2xl:py-4':
            (big == null || !big) && (icon === null || icon === ''),
          'text-sm pl-9 pr-7 py-2 xxl:pl-12 xxl:pr-8 xxl:py-3 2xl:pl-15 2xl:pr-9 2xl:py-4':
            (big == null || !big) && !(icon === null || icon === ''),
          'border-red-500': error && msgError != '',
          'border-indigo-600': !(error && msgError != ''),
        }"
        :placeholder="placeholder"
      />

      <div
        v-if="!(disabled || disabled_pass)"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-pink-600 px-4"
      >
        <icon name="chevron-down" />
      </div>

      <!-- Display value when hover -->
      <transition
        enter-active-class="duration-300 delay-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="
            tooltipValue &&
            mutableValue != null &&
            ((!valueIsObject && mutableValue != '') ||
              (valueIsObject && Object.keys(mutableValue).length > 0))
          "
          class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-full lg:max-w-128"
        >
          <span v-if="valueIsObject">
            {{ mutableValue.value }}
          </span>
          <span v-if="!valueIsObject && !isTooltipLibelle">
            {{ mutableValue }}
          </span>
          <span v-if="!valueIsObject && isTooltipLibelle">
            {{ datas.filter((d) => d.value == mutableValue)[0].libelle }}
          </span>
        </div>
      </transition>

      <!-- BEGIN Select field appears when click on input -->
      <div
        class="select-field z-20 absolute overflow-scroll max-h-60 mt-4 rounded-md bg-white shadow-lg shadow-gray-600 text-sm ml-auto w-max-content w-max max-w-full lg:max-w-128"
        :class="left ? '' : 'right-0'"
        :hidden="hide"
        v-clickOutside="forceHide"
        :name="name"
      >
        <div v-if="groups.length > 0" class="mx-5 my-3 text-left">
          <div
            v-if="emptyCase"
            @click="setEmptyValue"
            class="multi-select-element cursor-pointer pt-3 pb-3 hover:font-semibold text-gray-600"
          >
            --
          </div>
          <div
            class="multi-select-element cursor-default first:pb-3 py-3 last:pb-1 text-gray-900"
            v-for="group in groups"
            :key="group"
            :label="group"
          >
            {{ group }}
            <div
              v-for="(data, key) in datas.filter((d) => d.group === group)"
              :key="key"
              class="multi-select-element cursor-pointer first:pt-3 pb-3 hover:font-semibold last:pb-1 text-gray-600"
            >
              <span
                v-if="
                  data.libelle != undefined &&
                  data.libelle != null &&
                  data.libelle
                "
                @click="addEl"
                :value="data.value"
              >
                {{ data.libelle }}
              </span>
              <span v-else @click="addEl" :value="data.value">
                {{ data.value }}
              </span>
            </div>
          </div>
        </div>
        <div v-else class="mx-5 my-3 text-left">
          <div
            v-if="emptyCase"
            @click="setEmptyValue"
            class="multi-select-element cursor-pointer pt-3 pb-3 hover:font-semibold text-gray-600"
          >
            --
          </div>
          <div
            class="multi-select-element pb-3 last:pb-1 text-gray-600"
            :class="{
              'cursor-pointer hover:font-semibold':
                !data.disabled && !data.empty,
            }"
            :disabled="data.disabled"
            v-for="(data, index) in datas"
            :key="index"
            :num="index"
          >
            <span
              v-if="
                data.libelle != undefined &&
                data.libelle != null &&
                data.libelle
              "
              @click="addEl"
              :value="data.value"
            >
              {{ data.libelle }}
            </span>
            <span v-else @click="addEl" :value="data.value">
              {{ data.value }}
            </span>
          </div>
        </div>
      </div>
      <!-- END Select field appears when click on input -->
    </div>
    <div v-if="error" class="text-red-500 text-sm">
      {{ msgError }}
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';
import InfoBulle from '../../components/InfoBulle';
import Constants from './../../constants';
import ClickOutside from 'vue-click-outside';

export default {
  components: {
    Icon,
    InfoBulle,
  },

  props: {
    name: String,
    datas: Array,
    libelle: {
      type: String,
      required: false,
      default: '',
    },
    value: [String, Object, Number, Array],
    necessary: Boolean,
    inherits: Boolean,
    disabled: Boolean,
    valueIsObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: Boolean,
    msgError: {
      type: String,
      required: false,
      default: '',
    },
    labelLibelle: String,
    big: Boolean,
    placeholder: String,
    fixedText: String,
    required: Boolean,
    left: Boolean,
    emptyCase: {
      type: Boolean,
      required: false,
      default: true,
    },
    isTooltipLibelle: {
      type: Boolean,
      required: false,
      default: false,
    },
    libelleStyle: {
      type: String,
      required: false,
      default: 'text-sm text-gray-600',
    },
    libelleIcon: {
      type: String,
    },
    libelleIconStyle: {
      type: String,
      required: false,
      default: 'text-pink-600 h-2.5',
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    alwaysEnabledWhenNeoppassForm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: function () {
    return {
      hide: true,
      mutableValue: this.value,
      newDatas: [],
      first: true,
      groups: [],
      disabled_pass: false,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle: false,
      progressCount: true,
      textLibelle: '&nbsp;',
      textFixed: '',
      constants: Constants,
    };
  },

  updated() {
    this.makeGroups();
  },

  mounted() {
    this.makeGroups();

    // Manage edit permission for neopass pages
    if (this.$route.path.includes('form/neopass')) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if (
        this.$can(page + '_edit', idpass) ||
        page === Constants.PAGE_NEOPASS_FORM_DOCUMENTS ||
        this.alwaysEnabledWhenNeoppassForm
      ) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if (this.necessary != undefined && !this.necessary) {
      this.progressCount = false;
    }

    //assign text to textLibelle if prop Libelle is filled
    if (this.libelle != undefined && this.libelle != null) {
      this.textLibelle = this.libelle;
    }

    //assign text to textFixed if prop fixedText is filled
    if (this.fixedText != undefined && this.fixedText != null) {
      this.textFixed = this.fixedText;
    }
  },

  methods: {
    makeGroups() {
      // define optgroup
      this.datas.forEach((element) => {
        if (Object.keys(element).indexOf('group') > -1) {
          //if there is a field name "group" in the element
          if (!this.groups.includes(element.group)) {
            this.groups.push(element.group);
          }
        }
      });
    },

    setEmptyValue(e) {
      if (this.emptyCase) {
        if (this.valueIsObject) {
          this.mutableValue = {};
        }
        if (!this.valueIsObject) {
          console.log('set mutable value at empty');
          this.mutableValue = '';
        }
        this.$emit('input', this.mutableValue);
        this.displayMultiSelect(e);
      }
    },

    displayMultiSelect(e) {
      if (e.x < (2 * window.outerWidth) / 3) {
        //to move the bloc options on right or left according to the position on the screen
        document
          .querySelectorAll(".select-field[name='" + this.name + "']")[0]
          .classList.remove('right-0');
      }

      if (!this.disabled && !this.disabled_pass) {
        this.hide = !this.hide;
      }
    },

    displayLabelTooltip(e) {
      if (e.x < (2 * window.outerWidth) / 3) {
        document
          .querySelectorAll(".tooltip-label[name='" + this.name + "']")[0]
          .classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },

    forceHide(e) {
      if (
        e.target.classList.contains('select-input') &&
        e.target.name == this.name &&
        !this.disabled_pass
      ) {
        this.displayMultiSelect(e);
      } else {
        if (!this.hide) {
          this.hide = true;
        }
      }
    },

    forceHideTooltipLabel(e) {
      if (
        e.target.classList.contains('tooltip-label') &&
        e.target.name == this.name
      ) {
        this.tooltipLabel = !this.tooltipLabel;
      } else {
        if (this.tooltipLabel) this.tooltipLabel = false;
      }
    },

    addEl(e) {
      //function to atttribute select-input choice in mutableValue (value send in event @input)
      let data = e.target;

      if (!data.attributes.disabled) {
        if (this.valueIsObject) {
          //when valueIsObject is true, the value send is an object
          this.mutableValue = this.datas.filter(
            (d) =>
              d.value ==
              Object.values(data.attributes).filter(
                (attr) => attr.name == 'value'
              )[0].value
          )[0];
        } else {
          // else, it is the value with key "value"
          this.mutableValue = Object.values(data.attributes).filter(
            (attr) => attr.name == 'value'
          )[0].value;
        }

        this.displayMultiSelect(e);
      }
    },

    addData() {
      let count = this.newDatas.push({ value: '' });
      let lastId = count - 1;

      this.$nextTick(() => {
        this.$refs['new' + lastId][0].focus();
      });
    },

    keepFocus(e) {
      e.target.focus();
    },
  },

  computed: {
    computedValue: function () {
      //According to ValueIsObject and if libelle is filled, input display mutableValue, mutableValue.value or libelle.
      if (this.valueIsObject) {
        var value = this.datas.filter(
          (d) => d.value == this.mutableValue.value
        );
      } else {
        var value = this.datas.filter((d) => d.value == this.mutableValue);
      }

      if (value.length > 0) {
        let libelle = value[0].libelle;

        return libelle != undefined && libelle != null && libelle
          ? libelle
          : this.valueIsObject == true
          ? this.mutableValue.value
          : this.mutableValue + this.textFixed;
      } else {
        return '';
      }
    },
  },
  watch: {
    mutableValue() {
      this.$emit('loseFocus');

      if (!this.mutableValue) {
        return;
      }
      this.$emit('input', this.mutableValue);
    },
    value() {
      this.mutableValue = this.value;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style scoped>
.multi-select-element > span {
  display: block;
  width: 100%;
}
</style>
